import { useMemo, useState, useEffect } from "react";
import styles from "../SaveBig/SaveBig.module.css";
const plans = [
  {
    name: "Scaler",
    title: "Scaler",
    color: "#FE5E00",
    bg: "#FFECE0",
    minutes: "750",
    tag: "FREE VoIP Number",
    ulTitle: "Everything in Starter",
    features: [
      "750 minutes / month",
      "FREE VoIP Number",
      "Multi-Lingual with In-Call Language Switching",
      "Agent Characterization",
    ],
    additionalFeatureList: [
      "24/7 Availability",
      "Email Notifications",
      "SMS Notifications",
      "Website Widget Integration",
      "Speech Naturalization",
      "Environment Setup",
      "Calendar Integration using Cal.com",
      "Book Calendar Meetings",
      "Call History(Basic)",
      "Call Recording",
      "Call Transcript",
      "Intelligent Call Transfer(5)",
      "Caller Sentiment Analysis",
      "Intelligent Call Analysis",
      "Lead Type Analysis",
      "Lead Nurturing",
      "Business Knowledge Training",
      "Product & Services Training",
      "Spam Protection",
      "Profanity Protection",
      "CRM Integration(Coming Soon)",
      "Own Voice Implementation(Coming Soon)",
      "Human Email(Biz Hrs) & AI Chat & Call Support",
    ],
    popular: true,
    icon: "/Svg/Plan02.svg",
    pricing: {
      US: { currency: "USD", symbol: "$", monthly: 299, yearly: 249 },
      UK: { currency: "GBP", symbol: "£", monthly: 219, yearly: 183.25 },
      CA: { currency: "CAD", symbol: "$", monthly: 399, yearly: 333.25 },
      AU: { currency: "AUD", symbol: "$", monthly: 459, yearly: 383.25 },
    },
    
  },
  {
    name: "Starter",
    title: "Starter",
    color: "#E83BAC",
    bg: "#EFE5FF",
    minutes: "300",
    tag: "FREE VoIP Number",
    ulTitle: "Plan includes:",
    features: [
      "300 minutes / month",
      "FREE VoIP Number",
      "Agent Characterization",
      "Email Notifications",
    ],
    additionalFeatureList: [
      "24/7 Availability",
      "Website Widget Integration",
      "Speech Naturalization",
      "Environment Setup",
      "Calendar Integration using Cal.com",
      "Book Calendar Meetings",
      "Call History(Basic)",
      "Call Recording",
      "Intelligent Call Transfer(5)",
      "Intelligent Call Analysis",
      "Lead Nurturing",
      "Business Knowledge Training",
      "Product & Services Training",
      "Spam Protection",
      "Profanity Protection",
      "CRM Integration(Coming Soon)",
      "Own Voice Implementation(Coming Soon)",
      "Human Email(Biz Hrs) & AI Chat & Call Support",
    ],
    icon: "/Svg/Starter-Icon.svg",
    pricing: {
      US: { currency: "USD", symbol: "$", monthly: 119, yearly: 99 },
      UK: { currency: "GBP", symbol: "£", monthly: 89, yearly: 74 },
      CA: { currency: "CAD", symbol: "$", monthly: 159, yearly: 133.25 },
      AU: { currency: "AUD", symbol: "$", monthly: 179, yearly: 149.92 },
    },
  },
  {
    name: "Growth",
    title: "Growth",
    color: "#00A4FF",
    bg: "#E9F7FF",
    minutes: "1500",
    tag: "FREE VoIP Number",
    ulTitle: "Everything in Starter",
    features: [
      "1500 minutes / month",
      "FREE VoIP Number",
      "Multi-Lingual with In-Call Language Switching",
      "Agent Characterization",
    ],
    additionalFeatureList: [
      "24/7 Availability",
      "Email Notifications",
      "SMS Notifications",
      "Website Widget Integration",
      "Speech Naturalization",
      "Environment Setup",
      "Calendar Integration using Cal.com",
      "Book Calendar Meetings",
      "Call History(Advanced)",
      "Call Recording",
      "Call Transcript",
      "Intelligent Call Transfer(10)",
      "Caller Sentiment Analysis",
      "Intelligent Call Analysis",
      "Lead Type Analysis",
      "Lead Nurturing",
      "Business Knowledge Training",
      "Product & Services Training",
      "Spam Protection",
      "Profanity Protection",
      "CRM Integration(Coming Soon)",
      "Own Voice Implementation(Coming Soon)",
      "Human Email(Biz Hrs) & AI Chat & Call Support",
    ],
    icon: "/Svg/Plan03.svg",
    pricing: {
      US: { currency: "USD", symbol: "$", monthly: 599, yearly: 499 },
      UK: { currency: "GBP", symbol: "£", monthly: 439, yearly: 370.75 },
      CA: { currency: "CAD", symbol: "$", monthly: 819, yearly: 684.91 },
      AU: { currency: "AUD", symbol: "$", monthly: 919, yearly: 774.91 },
    },
  },
  // {
  //   name: "Corporate",
  //   title: "Corporate",
  //   color: "#22C95C",
  //   bg: "#E5FFEE",
  //   minutes: "3000",
  //   tag: "FREE VoIP Number",
  //   ulTitle: "Everything in Starter",
  //   features: [
  //     "3000 minutes / month",
  //     "FREE VoIP Number",
  //     "Multi-Lingual with In-Call Language Switching",
  //     "Agent Characterization",
  //   ],
  //   additionalFeatureList: [
  //     "24/7 Availability",
  //     "Email Notifications",
  //     "SMS Notifications",
  //     "Website Widget Integration",
  //     "Speech Naturalization",
  //     "Environment Setup",
  //     "Calendar Integration using Cal.com",
  //     "Book Calendar Meetings",
  //     "Call History(Advanced)",
  //     "Call Recording",
  //     "Call Transcript",
  //     "Intelligent Call Transfer(10)",
  //     "Caller Sentiment Analysis",
  //     "Intelligent Call Analysis",
  //     "Lead Type Analysis",
  //     "Lead Nurturing",
  //     "Business Knowledge Training",
  //     "Product & Services Training",
  //     "Spam Protection",
  //     "Profanity Protection",
  //     "CRM Integration(Coming Soon)",
  //     "Own Voice Implementation(Coming Soon)",
  //     "Human Email(Biz Hrs) & AI Chat & Call Support",
  //   ],
  //   icon: "/Svg/Plan04.svg",
  //   pricing: {
  //     US: { currency: "USD", symbol: "$", monthly: 999, yearly: 799 },
  //     UK: { currency: "GBP", symbol: "£", monthly: 739, yearly: 594.08 },
  //     CA: { currency: "CAD", symbol: "$", monthly: 1369, yearly: 1083.25 },
  //     AU: { currency: "AUD", symbol: "$", monthly: 1549, yearly: 1249.91 },
  //   },
  // },
];
const SaveBig = ({ country = "US", billing = "monthly", planName }) => {
  const isValidPlan = (name) => plans.some((p) => p.name === name);
  const [selectedPlan, setSelectedPlan] = useState(() =>
    isValidPlan(planName) ? planName : "Scaler"
  );
  useEffect(() => {
    if (isValidPlan(planName) && planName !== selectedPlan) {
      setSelectedPlan(planName);
    }
  }, [planName]);
  const [isOpen, setIsOpen] = useState(false);

  const currentPlan = useMemo(() => {
    return plans.find((p) => p.name === selectedPlan) || plans[0];
  }, [selectedPlan]);
  const key = useMemo(() => {
    const cc = (country || "US").toUpperCase();
    if (cc === "GB") return "UK";
    return ["US", "UK", "CA", "AU"].includes(cc) ? cc : "US";
  }, [country]);

  const priceObj = currentPlan.pricing[key];
  const priceValue = billing === "yearly" ? priceObj.yearly : priceObj.monthly;
  const priceLabel = "/monthly";

  const list = currentPlan.additionalFeatureList || [];
  const mid = Math.ceil(list.length / 2);
  const col1 = list.slice(0, mid);
  const col2 = list.slice(mid);

  return (
    <div className={styles.containerBox}>
      <div className={styles.container}>
        {/* Left Feature List */}
        <div className={styles.leftSection}>
          <h3 className={styles.heading}>~Standard Feature List</h3>
          <div className={styles.grid}>
            <ul>
              {col1.map((feat, idx) => (
                <li key={`c1-${idx}`}>✓ {feat}</li>
              ))}
            </ul>
            <ul>
              {col2.map((feat, idx) => (
                <li key={`c2-${idx}`}>✓ {feat}</li>
              ))}
            </ul>
          </div>
        </div>

        {/* Right Plan Box */}
        <div className={styles.rightSection}>
          <div className={styles.PlanCard}>
            <div className={styles.planTop}>
              <div className={styles.planTitle}>
                <div>
                  <img
                    src={currentPlan.icon}
                    alt={currentPlan.title}
                    className={styles.icon}
                  />
                </div>

                <div className={styles.minutDiv}>
                  <h4 className={styles.H4}>{currentPlan.title}</h4>

                  <div
                    className={styles.LeftBorderColor}
                    style={{
                      borderLeftColor: currentPlan.color,
                      transition: "border-color 0.4s ease",
                    }}
                  >
                    <p className={styles.MintNumber}>{currentPlan.minutes}</p>
                    <p className={styles.MintText}>minutes</p>
                  </div>

                  {/* Dropdown Button */}
                  <div
                    className={styles.dropdownBtn}
                    onClick={() => setIsOpen((prev) => !prev)}
                  >
                    <span
                      className={`${styles.arrow} ${
                        isOpen ? styles.rotate : ""
                      }`}
                    >
                      <img src="/Svg/drop-Arrow.svg" alt="drop-arrow" />
                    </span>
                  </div>

                  {/* Dropdown Menu */}
                  {isOpen && (
                    <div className={styles.dropdownMenu}>
                      {plans.map((plan) => (
                        <div
                          key={plan.name}
                          className={`${styles.dropdownItem} ${
                            selectedPlan === plan.name ? styles.activeItem : ""
                          }`}
                          onClick={() => {
                            setSelectedPlan(plan.name);
                            setIsOpen(false);
                          }}
                        >
                          <div
                            className={styles.colorDot}
                            style={{ backgroundColor: plan.color }}
                          />
                          {plan.name}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              <div className={styles.badges}>
                <span
                  className={styles.voip}
                  style={{
                    backgroundColor: currentPlan.bg,
                    color: currentPlan.color,
                    transition: "all 0.3s ease",
                  }}
                >
                  {currentPlan.tag}
                </span>
                {currentPlan.popular && (
                  <span className={styles.popular}>Most Popular Plan</span>
                )}
              </div>
            </div>

            {/* Features from currentPlan */}
            <div className={styles.planBody}>
              <h5>
                {currentPlan.ulTitle}
                {currentPlan.title !== "Starter" ? " ➕" : ""}
              </h5>
              <ul>
                {(currentPlan.features || []).map((feat, idx) => (
                  <li key={idx}>✓ {feat}</li>
                ))}
              </ul>
            </div>

            {/* Dynamic price by region & billing */}
            <div className={styles.priceWrap}>
              <span className={styles.price}>
                {priceObj.symbol}
                {priceValue}
              </span>
              <span className={styles.perMonth}>{priceLabel}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaveBig;
